import React, { useState } from "react";
import { Table, Row, Col, Button, Space, message } from "antd";
import DisqualificationsModal from "./DisqualificationsModal";
import { removePrevDisQualification } from "../../../../../services/vendorProfile.services";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { PrevDisqualificationsColumns } from "../../../../PQQ/tableColumns";

const Disqualifications = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const refreshPage = () => {
    props.fetchPrevDisQualification();
  };

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    removePrevDisQualification({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...PrevDisqualificationsColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Button
          type="secondary"
          style={{
            marginBottom: 16,
          }}
          onClick={openModal}
        >
          Add Action
        </Button>
        <Table
          size="small"
          columns={columns}
          dataSource={props.previousDisqualificationData}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>

      {visible && (
        <DisqualificationsModal
          setVisible={setVisible}
          title="Add Action"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default Disqualifications;
